import React from "react";
import kidBg from "../assets/bgcloud.png";

// images (you can replace later)
import hniImg from '../assets/hni.png';
import familyImg from '../assets/w2.png';
import businessImg from '../assets/w3.jpg';
import professionalImg from '../assets/w4.png';
import retireeImg from '../assets/w5.png';
import banner2 from '../assets/banner2.png';
const whoWeServeData = [
  {
    title: "High-Net-Worth Individuals (HNIs)",
    desc: `We work with affluent individuals who seek long-term wealth creation,
    capital preservation, and access to curated investment strategies —
    from PMS and equities to structured products and estate planning.`,
    image: hniImg,
  },
  {
    title: "Families & Multi-Generational Investors",
    desc: `Whether it’s planning for children’s education, building a family trust,
    or managing inter-generational wealth transfers, we guide families at
    every stage of their financial journey with care, clarity, and confidentiality.`,
    image: familyImg,
  },
  {
    title: "Corporates & Business Owners",
    desc: `From optimizing idle capital to ESOP liquidity planning, reserve
    management, and succession structuring, we help businesses grow and
    protect wealth with discipline and foresight.`,
    image: businessImg,
  },
  {
    title: "Professionals & First-Generation Wealth Creators",
    desc: `For doctors, CXOs, entrepreneurs, and salaried professionals, we design
    personalized investment plans that evolve with careers, lifestyles, and
    life goals — balancing growth with protection.`,
    image: professionalImg,
  },
  {
    title: "Retirees & Legacy Planning",
    desc: `We offer retirement income strategies, estate planning, and
    risk-managed portfolios to help you transition from accumulation
    to distribution — while preserving your legacy for the next generation.`,
    image: retireeImg,
  },
];

const WhoWeServe = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans">

      {/* HERO */}
       <section
        className="relative py-16 md:py-24 text-center overflow-hidden"
        style={{
          backgroundImage: `url(${banner2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        
       <h3 className="relative z-10 font-syne text-[24px] md:text-[32px] text-slate-900 tracking-tight font-medium">
         Who We Serve
        </h3>
        <div
          className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
          style={{
            background:
              "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
          }}
        />
      </section>
      
      

      {/* CONTENT */}
  <section className="py-20 md:py-28 bg-white">
  <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 space-y-32"> {/* Increased vertical space between rows */}

    {whoWeServeData.map((item, index) => {
      const isEven = index % 2 === 0;

      return (
        <div
          key={index}
          className="grid grid-cols-1 md:grid-cols-2 gap-16 lg:gap-24 items-center"
        >

          {/* IMAGE BLOCK */}
          <div className={`${!isEven ? "md:order-2" : ""} relative group w-full`}>
            <div className={`absolute -inset-1 md:-inset-4 bg-slate-50 rounded-[1.5rem] -z-10 transition-transform duration-500 group-hover:scale-105 ${isEven ? 'group-hover:rotate-1' : 'group-hover:-rotate-1'}`} />
            
            <img
              src={item.image}
              alt={item.title}
             
              className="w-full max-w-[520px] aspect-[16/9] rounded-[1.5rem]  object-cover mx-auto  transition-all duration-500 "
            />
            
            <div className={`absolute -bottom-4 ${isEven ? "-right-4" : "-left-4"} w-32 h-20 bg-red-600/5 rounded-full blur-3xl pointer-events-none`} />
          </div>

          {/* TEXT BLOCK */}
          <div className={`${!isEven ? "md:order-1" : ""} flex flex-col justify-center`}>
            {/* Added max-w-xl to the text container to prevent long lines */}
            <div className="max-w-xl">
             {/*  <h3 className="font-syne text-[24px] md:text-[32px] font-medium text-slate-900 mb-6 leading-tight">
                {item.title}
              </h3> */}
 
              <h3 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-5 leading-[1.1] whitespace-pre-line tracking-tighter">
  {item.title}
</h3>

              <p className="text-slate-600 text-[16px] md:text-[19px] leading-relaxed font-medium">
                {item.desc}
              </p>

              <div className="mt-8 w-16 h-[2px] bg-red-600 rounded-full" />
            </div>
          </div>

        </div>
      );
    })}

  </div>
</section>
      {/* CTA */}
      <section
        className="py-20 text-center"
        style={{
          backgroundImage: `url(${kidBg})`,
          backgroundSize: "cover",
        }}
      >
       
          <h2 className="font-syne text-2xl md:text-4xl font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter"> Let’s Build Your Financial Roadmap</h2>
        <p className="text-slate-600 text-[15px] md:text-[18px] mb-8 font-medium">
         Engage with our team to discuss disciplined asset allocation and suitable investment solutions designed for long-term wealth continuity.
        </p>
      
 <a
  href="/connect"
 
  rel="noreferrer"
  className="inline-flex items-center w-auto px-3 py-1 md:px-4 bg-red-600 border-2 border-red-600 text-white rounded-full hover:bg-[#434242] hover:border-[#434242] transition duration-300 font-medium text-[10px] md:text-[16px] shadow-xl shadow-red-900/20"
>             
  Connect With Us
</a>

      </section>

    </div>
  );
};

export default WhoWeServe;

